<template>
  <div class="etapas configuracoes" :value="idPublicacao" :controlePage="controlePage">
    <form @submit.prevent="editarConfiguracoes()">
      <div class="row">
        <div class="col-sm-6 mb-2" v-for="listar in listagemParametros" :key="listar.parametro">
          <div :id="removeAcento(listar.parametro)" style="height: 50px">
            <div v-if="listar.tipoparametro === 'Varchar'" class="mt-2">
              <fccInput
                extraClasses="inputLabel"
                v-model="form[listar.idpublicacaoparametropadrao]"
                required
                >{{ listar.parametro }} <span>*</span></fccInput
              >
            </div>
            <div v-else-if="listar.tipoparametro === 'Int'" class="mt-2">
              <fccInput
                type="number"
                extraClasses="inputLabel"
                v-model="form[listar.idpublicacaoparametropadrao]"
                required
                >{{ listar.parametro }} <span>*</span></fccInput
              >
            </div>

            <div v-else-if="listar.tipoparametro === 'Datetime'">
              <div class="datetimeShow">
                <label>{{ listar.parametro }}</label
                ><datetime
                  type="date"
                  v-model="form[listar.idpublicacaoparametropadrao]"
                  class="form-control my-2"
                  placeholder="Escolha a data"
                  required
                ></datetime>
              </div>
            </div>
            <div v-else-if="listar.tipoparametro === 'Bit'">
              <div>
                {{ listar.parametro }} <br /><toggle-button
                  v-model="form[listar.idpublicacaoparametropadrao]"
                />
              </div>
            </div>
            <div v-else>
              <fccInput
                extraClasses="inputLabel"
                v-model="form[listar.idpublicacaoparametropadrao]"
                required
                >{{ listar.parametro }} <span>*</span></fccInput
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div style="font-weight: bold">*Valida os arquivos diretamente na ficha(Nova)</div>
          Valida arquivos<br /><toggle-button
            v-model="controlePage.validaarquivos"
            @input="alteraPub"
            :sync="true"
          />
        </div>
        <div class="col-6">
          <div style="font-weight: bold">
            *Concatena dois campos -
            <a
              target="_blank"
              href="https://azuredevops.fcc.org.br/WORK/Projeto/_wiki/wikis/Projeto.wiki/131/Comarca"
              rel="noopener noreferrer"
              >Manual</a
            >
          </div>
          Valida comarca<br /><toggle-button
            v-model="controlePage.validacargocomarca"
            @input="alteraPub"
            :sync="true"
          />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <div style="font-weight: bold">*Valida cidade como chave</div>
          Valida cidade<br /><toggle-button
            v-model="controlePage.validacidade"
            @input="alteraPub"
            :sync="true"
          />
        </div>
        <div class="col">
          <div style="font-weight: bold">*Obrigatório envio de laudo</div>
          Valida Envio Laudo<br /><toggle-button
            v-model="controlePage.validaenviolaudo"
            @input="alteraPub"
            :sync="true"
          />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <div style="font-weight: bold">*Dispara e-mail para os candidatos</div>
          <toggle-button
            v-model="controlePage.validaconfirmaemail"
            @input="alteraPub"
            :sync="true"
          />
        </div>
        <div class="col">
          <div style="font-weight: bold">*O concurso possui foto na inscrição</div>
          <toggle-button v-model="controlePage.foto" @input="alteraPub" :sync="true" />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <div style="font-weight: bold">*Isenção antecipada sem a necessidade de inscrição</div>
          <toggle-button
            v-model="controlePage.isencaoliberadaantesinscricao"
            @input="alteraIsencao"
            :sync="true"
          />
        </div>

        <div class="col">
          <div style="font-weight: bold">*Mostrar linha digitável</div>
          <toggle-button
            v-model="controlePage.mostrarlinhadigitavel"
            @input="alteraPub"
            :sync="true"
          />
        </div>
      </div>
      <div class="row mt-3" v-if="controlePage.isencaoliberadaantesinscricao">
        <div class="col">
          <fcc-date-input
            class="form-control"
            v-model="controlePage.publicacaosir2monitdataisencaoaux.datainicio"
            required
            >Data Início Isenção</fcc-date-input
          >
        </div>
        <div class="col">
          <fcc-date-input
            class="form-control"
            v-model="controlePage.publicacaosir2monitdataisencaoaux.datafinal"
            required
            >Data Final Isenção</fcc-date-input
          >
        </div>
      </div>
      <hr />
      <div class="row my-3 buttonSalvar">
        <div class="col-sm-12 text-right">
          <fccButton tipo="submit">
            <font-awesome-icon icon="save" /> {{ labelsSystem.salvar }}</fccButton
          >
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      liberaPublicacao: '1',
      textoPublicacao: 'Configurações da Publicação',
      tipoPublicacao: this.controlePage.idpublictipo,
      listagemParametros: [],
      parametros: [],
      form: [],
      editar: {
        concurso: this.controlePage.concurso,
        idadeMinima: '',
        instituicao: this.controlePage.instituicao,
        dataConfirmacao: '',
        quantidadeInscricoes: ''
      }
    }
  },
  methods: {
    alteraPub() {
      this.$emit('alteraPublicacao', this.controlePage)
    },
    alteraIsencao() {
      this.controlePage.publicacaosir2monitdataisencaoaux = this.controlePage
        .isencaoliberadaantesinscricao
        ? {
            datainicio: '',
            datafinal: '',
            idpublicacao: this.controlePage.idPublicacao,
            id: 0
          }
        : null
    },
    montandoForm: function () {
      this.carregaTexto('Aguarde ...')
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoTipo/ListarPublicacaoTipoPorId/' +
            this.tipoPublicacao +
            '/' +
            this.controlePage.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data) {
            var resposta = response.data
            this.listagemParametros = resposta.listaparametros
            for (var x = 0, len = this.listagemParametros.length; x < len; x++) {
              var formThis = this.listagemParametros[x]
              if (formThis.tipoparametro === 'Bit') {
                var result = false
                if (formThis.valorpublicacao !== '0') {
                  result = true
                }
                this.form[formThis.idpublicacaoparametropadrao] = result
              } else {
                this.form[formThis.idpublicacaoparametropadrao] = formThis.valorpublicacao
              }
            }
          }
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    bolleanChange: function (bolleanB) {
      if (bolleanB === 0) {
        return false
      } else if (bolleanB === 1) {
        return 'true'
      } else if (bolleanB === true) {
        return '1'
      } else if (bolleanB === false) {
        return '0'
      } else {
        return bolleanB
      }
    },
    editarConfiguracoes: function () {
      for (var [key, value] of Object.entries(this.form)) {
        this.parametros.push({
          idpublicacaoparametro: key,
          valorpublicacao: this.bolleanChange(value)
        })
      }
      for (var x = 0, len = this.listagemParametros.length; x < len; x++) {
        var teste = this.listagemParametros[x].idpublicacaoparametropadrao
        if (!this.parametros.find((i) => i.idpublicacaoparametro === teste)) {
          this.parametros.push({
            idpublicacaoparametro: teste,
            valorpublicacao: 0
          })
        }
      }
      this.carregaTexto('Alterando Configurações ...')
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoConfiguracao/AlterarConfiguracao',
          this.parametros,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaTexto()
          this.alteraPub()

          this.callToast(this.mensagensUpdate.editado)
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    idPublicacao: Number,
    controlePage: Object
  },
  mounted: function () {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.montandoForm()
  }
}
</script>
<style >
.fccInput > fieldset legend.active {
  top: -0.8rem !important;
}
</style>